// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_LiabilityV1LukoToGetsafeDe = z.object({
  born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
  tariff_line: z.enum(['comfort']),
  family_coverage: z.boolean(),
  partner_last_name: z.string().optional(),
  partner_first_name: z.string().optional(),
  sleep_well_coverage: z.boolean(),
  rented_vehicles_coverage: z.boolean(),
  number_of_claims_in_last_3y: z.enum(['0-2', '3+']).optional(),
  cancelled_by_previous_insurer: z.boolean().optional(),
})

const Schema_LiabilityV1LukoToGetsafeDe = BaseSchema_LiabilityV1LukoToGetsafeDe

export default Schema_LiabilityV1LukoToGetsafeDe
